import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getProjectOverview = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/overview`
  return doGet(url)
}

export const getprojectInfo = (id) => {
  const url = `${API_ROOT}/proposal/${id}/witget/project`
  return doGet(url)
}

export const getInviteValidate = (id) => {
  const url = `${API_ROOT}/proposal/${id}/invited/validate`
  return doGet(url)
}

// ---------------------------------- subproject

export const getProjectOverviewSubProject = (id) => {
  // const API_ROOT = 'http://localhost:9012/api'
  const url = `${API_ROOT}/subproject/${id}/overview`
  return doGet(url)
}

export const getSubProjectPDPA = (projectVersionId, projectCode, skip) => {
  // const API_ROOT = 'http://localhost:9012/api'
  const url = `${API_ROOT}/subproject/pdpa/get?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}&skip=${skip || 0}`
  return doGet(url)
}

export const saveSubProjectPDPA = (projectVersionId, projectCode) => {
  const url = `${API_ROOT}/subproject/pdpa/accept?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}`
  return doPost(url)
}

// ----------------------------------

export const getListBudgetReport = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/project-total-workplan`
  return doGet(url)
}

export const getPreviousProjectVersionId = (projectVersionId, masterSubjectId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/project/previousprojectversionid/get?subjectId=${masterSubjectId || ''}`
  return doGet(url)
}

export const getOverviewCurrentStatus = (projectVersionId = null, projecCode = null) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/dashboard/overview-current-status?projectVersionId=${projectVersionId}&projectCode=${projecCode}`
  return doGet(url)
}
